// ---------------------------------------------------------------------------
// Prezio Onboard Widget — Spinner
// ---------------------------------------------------------------------------
// CSS-only spinning indicator. Two sizes: 'sm' (16px) and 'md' (24px).
// ---------------------------------------------------------------------------

import styles from './Spinner.module.css';

interface SpinnerProps {
  size?: 'sm' | 'md';
}

export function Spinner({ size = 'md' }: SpinnerProps) {
  return (
    <span className={styles[size]} role="status" aria-label="Loading">
      <span className={styles['visuallyHidden']}>Loading…</span>
    </span>
  );
}
